import React, { Component } from 'react';
import { Header, Segment, Grid, Form, Button, Image, Table, Divider } from "semantic-ui-react"
import ReactSignatureCanvas from 'react-signature-canvas'
import html2canvas from "html2canvas"
import moment from 'moment';
import { update } from '../../../data/user_api';

export default class VisualElecGenerator extends Component {

    constructor(props) {
        super(props);
        this.state = {
            categories:{
                "Meter Equipment": [],
                "Consumer Unit (Fuse Box)": [],
                "RC Device": [],
                "Fixtures and Fittings": [],
                "Electrical Appliances": []
            },
            trimmedImage: null,
            generatedSOCImage: null,
            dateOfInspection: "",
            propertyAddress: "",
            initialized: false,
            clearOnResize:false,
        };
        this.sigPad = {}
    }
    componentDidMount() {
        let categoriesDict =
        {
            "Meter Equipment": [{
                "comments": "", "response": "","text": "There are no visual signs of burning, overheating or damage and no burning smell at the electrical intake position (usually where the consumer unit and electricity meter are located).*",
            }, {  "comments": "", "response": "","text":"The electrical intake position and consumer unit are easily accessible and free from storage materials" }
            ],
            "Consumer Unit (Fuse Box)": [
                { "comments": "", "response": "","text": "There are no blanks missing from the consumer unit.*"},
                { "comments": "", "response": "","text": "The consumer unit is correctly labelled for identification of circuits.*"},
                { "comments": "", "response": "","text": "There are no noticeable signs of electrical burning near the consumer unit/ electricity meter (by smell or visual evidence).*"}],
            "RC Device": [{"comments": "", "response": "","text":"30mA RCD(s) are present in the consumer unit. † Please state if not applicable due to RCD(s) being present on all sockets (by writing NA in the tick box)."},
                {"comments": "", "response": "","text":"I have operated the test button(s) on these RCD(s) during the course of this inspection and confirm they are operating properly."},
                {"comments": "", "response": "","text":"RCD(s) not present in consumer unit, but sockets are provided with RCD protection and the test button on each has been operated within the last quarter. Please state if not applicable because RCDs are present in the consumer unit only (by writing NA in the tick box)."}
            ],
            "Fixtures and Fittings": [{"comments": "", "response": "","text":"All fittings (light fittings / sockets /switches / outlets / showers / storage heaters etc.) on the premises are tightly secured in their back box, with all screws present."},
                {"comments": "", "response": "","text":"All sockets on the premises are working (i.e. power a simple appliance such as a lamp)."},
                {"comments": "", "response": "","text":"No fittings (light fittings / sockets /switches / outlets / showers / storage heaters etc.) on the premises show signs of burning or damage."},
                {"comments": "", "response": "","text":"There are no signs of modification/alteration to the electrical installation from the previous tenant."}
            ],
            "Electrical Appliances":[{"comments": "", "response": "","text":"All portable electrical appliances supplied by the landlord have been visually inspected and tested where applicable and possible"}]}
        if (this.props.reportDetails) {
            this.setState({
                categories: categoriesDict,
                initialized: true,
                propertyAddress: this.props.reportDetails.address,
                dateOfInspection: moment(this.props.reportDetails.inspection_date, "YYYY-MM-DD").format("DD-MM-YYYY"),
            })
        }
        else {
            this.setState({ categories: categoriesDict, initialized: true })
        }
      }
    render() {

        let generateSOCImage = async () => {
            this.setState({generatingCanvas:true})
            html2canvas(document.getElementById('domGen'), { backgroundColor: null }).then(canvasObject => { this.setState({ generatedSOCImage: canvasObject.toDataURL('image/png'),generatingCanvas:false });})
        }

        let saveImage = () => {
            const link = document.createElement('a')
        link.download = 'soc_image.png'
        link.href = this.state.generatedSOCImage
        link.click()
        }

        let updateCategory = async (category, updateState) => {
            this.setState({ initialized: false,generatedSOCImage:null })
            let newState = { ...this.state }
            newState.categories[category] = { ...updateState }
            this.setState(...newState)
            this.setState({ initialized: true })
        }

        let updateResponse = async (category, index, response) => {
            this.setState({ initialized: false,generatedSOCImage:null })
            let newState = { ...this.state }
            newState.categories[category][index].response = response
            this.setState(...newState)
            this.setState({ initialized: true })
        }

        let updateComment = async (category, index, comment) => {
            this.setState({ initialized: false,generatedSOCImage:null })
            let newState = { ...this.state }
            newState.categories[category][index].comments = comment
            this.setState(...newState)
            this.setState({ initialized: true })
        }
        let categoriesArr = [
            "Meter Equipment",
            "Consumer Unit (Fuse Box)",
            "RC Device",
            "Fixtures and Fittings",
            "Electrical Appliances"]

        return <Segment  className="pad-top">
            <Form>
                <Grid className="soc-grid" stackable columns={3}>
                    <Grid.Row>
                        <Grid.Column width={16}><Header size='large' textAlign='center' className="icon-button">Visual Electrical Checklist Image Generator</Header>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={16}><Divider/><Header size='large' textAlign='center' className="icon-button">General Information</Header>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                    <Grid.Column className="pad-top">
                            <Segment>
                                <Header align="center">Property Address</Header>
                                <Form.Input
                                        placeholder="Property Address"
                                    fluid
                                    value={this.state.propertyAddress}
                                    onChange={(e, option) => {
                                        this.setState({propertyAddress:option.value})}} />
                            </Segment>
                        </Grid.Column>
                        <Grid.Column className="pad-top">
                            <Segment>
                                <Header align="center">Date of Inspection</Header>
                                <Form.Input
                                        placeholder="Date of Inspection"
                                    fluid
                                    value={this.state.dateOfInspection}
                                    onChange={(e, option) => {
                                        this.setState({dateOfInspection:option.value})}} />
                            </Segment>
                        </Grid.Column>
                        <Grid.Column className="pad-top">
                            <Segment>
                                <Header align="center">Type of Inspection</Header>
                                <Form.Input
                                        placeholder="Type of Inspection"
                                    fluid
                                    value={this.state.inspectionType}
                                    onChange={(e, option) => {
                                        this.setState({inspectionType:option.value})}} />
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <Grid className="soc-grid" stackable columns={1}>
                    <Grid.Row>    
                    {categoriesArr.map((category) => {
                        return <Grid.Column key={category} className="pad-top">
                            <Segment >
                                <Header align="center">{category}</Header>
                                <Grid className="soc-grid"  divided='vertically' stackable columns={1}>
                                    <Grid.Row>
                                {this.state.categories[category].map((question, index) => {
                                    return <Grid.Column key ={category + index}><Segment secondary><Segment>{question.text}</Segment>
                                        <div style={{textAlign:"center"}}>
                                            <Button color={question.response == "yes" ? "blue" : null} active={question.response == "yes"} onClick={() =>updateResponse(category,index,"yes")}>Yes</Button>
                                            <Button color={question.response == "no" ? "blue" : null} active={question.response == "no"}onClick={() =>updateResponse(category,index,"no")} >No</Button>
                                            <Button color={question.response == "na" ? "blue" : null} active={question.response == "na"} onClick={() =>updateResponse(category,index,"na")}>N/A</Button></div>
                                        <div>
                                            <Form.TextArea label="Additional Comments" onChange={(e) => {updateComment(category,index,e.target.value)}} />
                                        </div></Segment></Grid.Column>
                                })}
                                    </Grid.Row>
                                </Grid>
                            </Segment>
                        </Grid.Column>
                    })}
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={16}>
                        <Segment>
                            <Header align="center">Additional Comments</Header>
                            <Form.TextArea onChange={(e) => {this.setState({additionalComments:e.target.value})}} />
                            </Segment>
                            </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={16}>
                             <Segment style={{ textAlign: "center", overflow: "auto" }}>
                                <Header>Preview - Can Scroll Horizontally On Mobile</Header>
                                {this.state.initialized &&<div style={{ minWidth: "600px", padding: "10px", textAlign: "center", maxWidth: "800px", margin: "auto" }}>
                                    <Table celled id="domGen" className="soc-table" compact="very" size="small" unstackable structured textAlign="center">
                                        <Table.Body>
                                        <Table.Row>
                                                <Table.Cell colSpan={5}><strong>Visual Electrical Checklist</strong></Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell width={2}><strong>Property Address</strong></Table.Cell>
                                                <Table.Cell colSpan={4}>{this.state.propertyAddress}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell width={2}  className="header-active" ><strong>Date Of Inspection</strong></Table.Cell>
                                                <Table.Cell width={2}>{this.state.dateOfInspection}</Table.Cell>
                                                <Table.Cell width={2} className="header-active"><strong>Inspection Type</strong></Table.Cell>
                                                <Table.Cell width={2}>{this.state.inspectionType}</Table.Cell>
                                                <Table.Cell width={1} className="header-active-sub"></Table.Cell>   
                                            </Table.Row>
                                            {Object.keys(this.state.categories).map((key => {
                                                return <React.Fragment><Table.Row>
                                                    <Table.Cell colSpan={5} className="header-active"><strong>{key}</strong></Table.Cell></Table.Row>
                                                    {this.state.categories[key].map((question) => {
                                                        return <Table.Row>
                                                            <Table.Cell  className="header-active-sub" colSpan={4}>{question.text}</Table.Cell>
                                                            <Table.Cell width={2}>{question.response.toUpperCase() + " " + question.comments}</Table.Cell>
                                                        </Table.Row>
                                                    })}
                                                    </React.Fragment>
                                            }))}
                                            <Table.Row>
                                                <Table.Cell width={2}><strong>Additional Comments</strong></Table.Cell>
                                                <Table.Cell colSpan={4}>{this.state.additionalComments}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell  className="header-active-sub"colSpan={5}>Visual Inspection Checklist will be valid for 1 year after the above date for this property</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell  className="header-active-sub"colSpan={5}>*If you are unable to check this box, immediate action is required. Please contact a competent, registered electrician at your earliest convenience. Competent electricians can be found at www.electricalcompetentperson.co.uk</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell  className="header-active-sub"colSpan={5}>† 30mA RCDs are designed to prevent fatal electric shocks. If an RCD of this rating is not present, it is strongly recommended that you have one fitted by a competent, registered electrician</Table.Cell>
                                            </Table.Row>
                                        </Table.Body>
                                    </Table>
                                </div>}
                                {!this.state.initialized && <Button onClick={() => { this.setState({ initialized: true, generatedSOCImage:null })}}>Generate Table</Button>}
                            </Segment>
                            
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <Segment style={{textAlign:"center"}}>
                                {this.state.initialized && <React.Fragment><Button loading={this.state.generatingCanvas} primary compact onClick={() => { generateSOCImage() }}>Generate SOC Image</Button> {this.state.generatedSOCImage && <React.Fragment><Button compact onClick={() => { saveImage() }}>Save Image</Button>{this.props.reportDetails && <Button compact onClick={() => { this.props.useImage(this.state.generatedSOCImage) }}>Use Image In Report</Button>}</React.Fragment>}
                                    <Image style={{ margin: "auto", maxWidth: "100%" }} className={"pad-top"} src={this.state.generatedSOCImage} />
                                </React.Fragment>}</Segment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Form>
      </Segment>
  }
}




// WEBPACK FOOTER //
// ./src/views/report/visual_elec_generator/visual_elec_generator.js